<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h3>{{ title }}</h3>

        <button
          type="button"
          aria-label="Close"
          @click="closeModal"
        >
          &times;
        </button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="submitForm">
          <div class="privacy-note">
            Enter the email address the vendor used to register with Blessed FMS.
            The system will securely locate and connect that vendor to your account.
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 font-bold mb-2">
              Vendor Email Address
              <span class="text-red-500">*</span>
            </label>

            <input
              v-model.trim="vendorEmail"
              type="email"
              autocomplete="email"
              class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:ring focus:border-blue-500"
              placeholder="vendor@example.com"
              required
            />
          </div>

          <div class="mb-4">
            <label class="block text-gray-700 font-bold mb-2">
              Hire Date
              <span class="text-red-500">*</span>
            </label>

            <input
              v-model="hireDate"
              type="date"
              class="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:ring focus:border-blue-500"
              required
            />
          </div>

          <div class="flex justify-end gap-2">
            <button
              type="button"
              class="bg-gray-400 text-white font-bold py-2 px-4 rounded hover:bg-gray-500"
              @click="closeModal"
            >
              Cancel
            </button>

            <button
              type="submit"
              class="bg-emerald-600 text-white font-bold py-2 px-4 rounded hover:bg-emerald-500"
              :disabled="!canSubmit"
              :class="{ 'opacity-50 cursor-not-allowed': !canSubmit }"
            >
              Add Vendor
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HireVendorModal",

  props: {
    show: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      default: "Add Vendor",
    },
  },

  emits: ["close", "submit"],

  data() {
    return {
      vendorEmail: "",
      hireDate: this.getToday(),
    };
  },

  computed: {
    canSubmit() {
      return this.vendorEmail.trim() !== "" && this.hireDate !== "";
    },
  },

  watch: {
    show(isVisible) {
      if (isVisible) {
        this.resetForm();
      }
    },
  },

  methods: {
    getToday() {
      return new Date().toISOString().slice(0, 10);
    },

    submitForm() {
      if (!this.canSubmit) {
        return;
      }

      this.$emit("submit", {
        vendor_email: this.vendorEmail.trim().toLowerCase(),
        hire_date: this.hireDate,
      });
    },

    closeModal() {
      this.resetForm();
      this.$emit("close");
    },

    resetForm() {
      this.vendorEmail = "";
      this.hireDate = this.getToday();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 1040;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.22);
  z-index: 1050;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
}

.modal-header button {
  background: none;
  border: none;
  font-size: 1.75rem;
  cursor: pointer;
  color: #64748b;
}

.modal-body {
  padding-top: 1rem;
}

.privacy-note {
  padding: 0.85rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #065f46;
  font-size: 0.875rem;
}
</style>
